@let isLoading =
  employeesEc.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();
@let jobTitleLookup =
  jobTitlesEc.plugins.cachePlugin.feature.selectors.lookup.asSignal();
@let employees = employeesSg();
@let selectedEmployees = selectedEmployeesSg();
@let showExpandButton = showExpandButtonSg();
@let expanded = expandedSg();
@let departmentOptions = departmentOptionsSg();
@let orgFilter = orgFilterSg();
@let nameSearch =
  employeesEc.plugins.currentListPlugin.appliedParams.selectors.search.asSignal();

<atn-ds-text
  label="Employee Name"
  placeholder="Search by name"
  [value]="nameSearch"
  (change)="onNameSearchChange($event)"
/>
<atn-ds-select-multiple
  label="Department"
  [config]="{
    overlay: {
      minSearchCharacters: 1,
      hasSearch: true,
    },
  }"
  [items]="departmentOptions"
  [value]="orgFilter?.recordIds ?? []"
  (valueChange)="onDepartmentChange($event)"
  placeholder="Select department"
/>

<div class="atn-space-modal-employee-selector__header">
  <span><b>Employees</b></span>
  <i
    class="atn-icon atn-plus atn-blue"
    (click)="createEmployeeClickHandler()"
  ></i>
</div>
<div class="atn-space-modal-employee-selector__selection-section">
  <!-- Selected employees as dismissible tags -->
  @if (selectedEmployees.length > 0) {
    <div class="atn-space-modal-employee-selector__selected">
      <div
        [ngClass]="[
          expanded
            ? 'atn-space-modal-employee-selector__selected-items-expanded'
            : 'atn-space-modal-employee-selector__selected-items',
        ]"
        #selectItemsContainerRef
      >
        @for (employee of selectedEmployees; track employee.id) {
          <div #selectedItemRef>
            <atn-ds-tag
              [text]="employee.name"
              (close)="employeeRemoved.emit(employee.id)"
            ></atn-ds-tag>
          </div>
        }
      </div>
      @if (showExpandButton) {
        <div
          class="atn-space-modal-employee-selector__expander-button"
          (click)="toggleExpandButtonClickHandler()"
        >
          {{ expanded ? 'Hide' : 'Show' }}
        </div>
      }
    </div>
  }

  <!-- Employee list with checkboxes -->
  <div class="atn-space-modal-employee-selector__employees">
    @if (isLoading) {
      <div class="atn-space-modal-employee-selector__employees-loading">
        <atn-ds-loader />
      </div>
    } @else if (employees.length > 0) {
      @for (employee of employees; track employee.id) {
        <div class="atn-space-modal-employee-selector__row">
          <atn-ds-checkbox
            [selected]="isEmployeeSelected(employee.id)"
            (selectedChange)="
              employeeToggled.emit({ id: employee.id, selected: $event })
            "
            [label]="getEmployeeLabel(employee, jobTitleLookup)"
          ></atn-ds-checkbox>
        </div>
      }
    } @else {
      <div class="atn-space-modal-employee-selector__employees-empty">
        No employees available
      </div>
    }
  </div>
</div>
